import styled from 'styled-components';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSection';
const HomeSectionInner = styled(MainSectionInner).withConfig({
  displayName: "HomeSectionInner",
  componentId: "i6749m-0"
})(["max-width:", "px;padding:0;background-color:transparent;"], props => props.maxWidth != null ? props.maxWidth : 940);
export default HomeSectionInner;